<template>
  <Layout>
    <ServerStatusListPage
      title="Incomplete Applications"
      subtitle="Applications sent back to the applicant for corrections."
      card-title="Incomplete"
      icon="trending-up"
      tone="amber"
      by-label="Reviewed By"
      search-placeholder="Search incomplete application..."
      empty-message="No incomplete applications"
      endpoint="/applications/incomplete_applications/"
      :status="status"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ServerStatusListPage from "@/components/shared/ServerStatusListPage.vue";
import { APPLICATION_STATUS } from "@/constants";

// Shared by staff and admin; paging / search / sort are server-side and kept in the URL.
export default {
  components: {
    Layout,
    ServerStatusListPage,
  },
  data() {
    return { status: APPLICATION_STATUS.INCOMPLETE };
  },
};
</script>